<template>
  <section class="department">
    <sk-input :placeholder="placeholder"
              :preselected-value="departmentSearchKey"
              @fieldvaluechanged="onInputBoxChanged" />
  </section>
</template>

<script>
  export default {
    data() {
      return {
        departmentSearchKey: '',
        requestTimer: ''
      };
    },
    computed: {
      placeholder() { return this.$gettext('Department name'); },
    },
    methods: {
      onInputBoxChanged(value) {
        if (value !== this.departmentSearchKey) {
          clearInterval(this.requestTimer);
          this.departmentSearchKey = value;
          this.requestTimer = setTimeout(() => {
            this.params.parentFilterInstance((instance) => {
              instance.onFloatingFilterChanged('contains', value);
            });
          }, 500);
        }
      },

      onParentModelChanged(parentModel) {
        // When the filter is empty we will receive a null value here
        if (!parentModel) {
          this.departmentSearchKey = '';
        }
      }
    }
  };
</script>

<style>
.department .sk-input {
  margin-bottom: 0;
  background-color: #fff;
  font-weight: normal;
  font-size: 13px;
}

.department {
  width: 100%;
  margin: auto;
}
</style>
